
    <ng-container *ngIf="state && !state.done">
      <div class="progress" style="height:20px;margin-top:8px;">
        <div class="progress-bar" role="progressbar" *ngIf="state.percent != null" [style.width.%]="state.percent">{{state.percent}}%</div>
        <div class="progress-bar progress-bar-striped active" role="progressbar" *ngIf="state.percent == null" style="width:100%"></div>
      </div>
      <span *ngIf="state.phase" style="color:#666;">{{state.phase}}</span>
    </ng-container>